import { createReducer } from "redux-starter-kit";
import {
  setUploadItemLoadedIDAction,
  setUploadItemLoadErrorAction,
  setUploadItemSetDataAction,
  setUploadItemAppendDataAction,
  modifyUploadItemAction,
  removeMediaItemAction
} from "../actions/issueMediaUploader";

const INIT_STATE = {
  loadedIsPdf: null,
  loadedIssueID: null,
  errMsg: null,

  mediaIDs: [],
  mediaDicts: {}
};

const issueMediaUploader = createReducer(INIT_STATE, {
  [setUploadItemLoadedIDAction]: (state, action) => {
    state.loadedIssueID = action.payload.loadedIssueID;
    state.loadedIsPdf = action.payload.loadedIsPdf;
  },
  [setUploadItemLoadErrorAction]: (state, action) => {
    state.errMsg = action.payload.errMsg;
  },
  [setUploadItemSetDataAction]: (state, action) => {
    state.mediaIDs = action.payload.mediaIDs;
    state.mediaDicts = action.payload.mediaDicts;
  },
  [setUploadItemAppendDataAction]: (state, action) => {
    state.mediaIDs.unshift(action.payload.id);
    state.mediaDicts[action.payload.id] = action.payload.media;
  },
  [modifyUploadItemAction]: (state, action) => {
    if (action.payload.progress != null) {
      state.mediaDicts[action.payload.id].progress = action.payload.progress;
    }

    if (action.payload.serverData != null) {
      state.mediaDicts[action.payload.id].serverData =
        action.payload.serverData;
    }
  },
  [removeMediaItemAction]: (state, action) => {
    state.mediaIDs = state.mediaIDs.filter(id => id !== action.payload.id);
    state.mediaDicts[action.payload.id] = null;
  }
});

export default issueMediaUploader;
